// extracted by mini-css-extract-plugin
export var description = "styles-module--description--gIE66";
export var header = "styles-module--header--ZXn2T";
export var root = "styles-module--root--zwoSV";